import { broadcastLogout } from './logoutSync';

/**
 * Utility function to handle user logout via POST request
 * This avoids putting form_key in the URL for better security
 */
export function handleLogout(formKey: string): void {
  // Clear per-user preferences so the next user on this browser doesn't
  // inherit theme, layout, dismissed notices, etc.
  localStorage.removeItem('ipt:preferences');

  // Tell other open tabs to redirect to the login page too.
  broadcastLogout();

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/user/logout';

  const formKeyInput = document.createElement('input');
  formKeyInput.type = 'hidden';
  formKeyInput.name = 'form_key';
  formKeyInput.value = formKey;
  form.appendChild(formKeyInput);

  document.body.appendChild(form);
  form.submit();
}
